import r from"./_baseIsEqualDeep.js";import e from"./isObjectLike.js";var t=r,a=e;var l=function r(e,l,o,s,u){return e===l||(null==e||null==l||!a(e)&&!a(l)?e!=e&&l!=l:t(e,l,o,s,r,u))};export{l as default};
//# sourceMappingURL=_baseIsEqual.js.map
